import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import Icon from 'kingpin/atoms/Icon';
import Typography from 'kingpin/atoms/Typography';

import { ColumnDragGhostDiv } from './DataTable.styles';

// Below and to the right of the pointer, clear of the header under it
const OFFSET_X = 12;
const OFFSET_Y = 8;

// The dragged column's (or group's) name beside the pointer, with what
// letting go does: moves it, or hides it once dragged off the table. Follows
// the pointer itself, so the table doesn't redraw as it moves.
const ColumnDragGhost = ({
  label,
  isHiding,
  start,
}: {
  label: string;
  isHiding: boolean;
  // Where the pointer was when the drag began
  start: { x: number; y: number };
}) => {
  const [position, setPosition] = useState(start);
  useEffect(() => {
    const onMove = (event: PointerEvent) =>
      setPosition({ x: event.clientX, y: event.clientY });
    window.addEventListener('pointermove', onMove);
    return () => window.removeEventListener('pointermove', onMove);
  }, []);

  return createPortal(
    <ColumnDragGhostDiv
      data-testid="dt-column-drag-ghost"
      style={{
        transform: `translate(${position.x + OFFSET_X}px, ${
          position.y + OFFSET_Y
        }px)`,
      }}
    >
      {isHiding ? (
        <Icon icon="visibilityOff" testId="dt-column-drag-ghost-hide" />
      ) : (
        <Icon icon="move" testId="dt-column-drag-ghost-move" />
      )}
      <Typography.Body
        type="Body 12"
        color="var(--color-text-primary)"
        isEllipsis
      >
        {label}
      </Typography.Body>
    </ColumnDragGhostDiv>,
    document.body,
  );
};

export default ColumnDragGhost;
